import { defineComponent, createElement as h, computed, provide } from '@vue/composition-api';

export default defineComponent({
    name: 'WokDataGridRowWrapper',

    props: {
        item: {
            type: Object,
            required: true
        },
    },

    setup(props, ctx) {
        // Inject properties into the component created from the slot.
        provide('wokDataGridRowProps', props);

        // This is a bit of a hack but apparently there is no way to
        // pass props to a child scope. I.e., the following code does
        // not set the properties:
        //
        // return ctx.slots.default && ctx.slots.default(props);

        return () => {
             return ctx.slots.default && ctx.slots.default();
        }
    }
})
